export interface HolidayHours {
  valid: Valid;
  periodNext: number;
  pPeriod: number;
  socialSecurityDays: number;
  periodTypeSvc: PeriodTypeSVC;
  yearNext: number;
  pYear: number;
  periodSetupId: number;
  periodPrev?: number;
  yearPrev?: number;
  holidayHours?: number;
  bo4WeekNr?: number;
}

export enum PeriodTypeSVC {
  y = 'y',
  p = 'p',
  m = 'm',
  d = 'd',
  f = 'f',
  w = 'w'
}

export interface Valid {
  from: string;
  to: string;
}

export interface PeriodTypes {
  code: PeriodTypeSVC;
  groupId: number;
  name: string;
  id: number;
}
